import { createFileRoute } from '@tanstack/react-router'
import { DelegationOfAuthorityPage } from '../-components/DelegationOfAuthorityPage'

export const Route = createFileRoute(
  '/_auth/_modules/credit/admin/users/delegation-of-authority/single-with-deviation/',
)({
  component: () => <DelegationOfAuthorityPage type="single_with_deviation" />,
})
